<div class="rss_properties">
    <small class="debug">{{ me }}</small>
    @if (dynamicsInitialized) {
        <div>
            <dynamic-form [fields]="uiConfigInit" (submit)="submit($event)">
            </dynamic-form>
            <hr/>
            @if (rssEmbeddedDataSource.length > 0) {
                <div>
                    <br/>
                    <mat-label>
                        {{ 'general.embeddedRSS' | transloco }}
                    </mat-label>
                    <br/>
                    <br/>
                    <app-button-bar [items]="highlightedRows" [setButtons]="buttons" (buttonEmit)="$event.name === 'add' ? onEmbeddedAdded($event) : onEmbeddedRemoved($event)"></app-button-bar>
                    <table mat-table [dataSource]="rssEmbeddedDataSource" class="mat-elevation-z8" multiTemplateDataRows>
                        <!-- <ng-container matColumnDef="title">
                        <th mat-header-cell *matHeaderCellDef>{{'general.title' | transloco}} </th>
                        <td mat-cell matTooltip="" title="click to edit" class="textAlignLeft" *matCellDef="let element; let index = index">
                          <editable (update)="onEmbeddedUpdated('title',index, element, $event)">
                            <ng-template viewMode>
                              {{element.title[0] | PipeTruncate:['15']}}
                            </ng-template>
                            <ng-template editMode>
                              <input inputrestriction="basic3"  matTooltip="enter to finish" style="width: 100px !important;" #editInput value="{{element.title[0]}}" focusable editableOnEnter>
                            </ng-template>
                          </editable>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="description">
                        <th mat-header-cell *matHeaderCellDef>{{'general.description' | transloco}} </th>
                        <td mat-cell matTooltip="" title="click to edit" class="textAlignLeft" *matCellDef="let element; let index = index">
                          <editable (update)="onEmbeddedUpdated('description',index, element, $event)">
                            <ng-template viewMode>
                              {{element.description[0] | PipeTruncate:['15']}}
                            </ng-template>
                            <ng-template editMode>
                              <input inputrestriction="basic3"  matTooltip="enter to finish" style="width: 100px !important;" #editInput value="{{element.description[0]}}" focusable editableOnEnter>
                            </ng-template>
                          </editable>
                        </td>
                      </ng-container> -->
                        @for (column of displayedColumns; track column; let index = $index) {
                            <ng-container [matColumnDef]="column">
                                <th mat-header-cell *matHeaderCellDef>{{ 'general.' + column | transloco }}</th>
                                <td mat-cell class="textAlignLeft tableListItems" *matCellDef="let element">
                                    {{ element[column][0] | PipeTruncate:['15'] }}
                                    @if (index === 1 && element != expandedRow) {
                                        <span class="drgIcon"
                                              (click)="onExpandRow(element)">
                    <!--                            <mat-icon matTooltip="{{'general.edit' | transloco}}">edit</mat-icon>-->
                    <mat-icon [ngStyle]="{'color': 'var(--background-green)'}" style="font-size: 18px !important;" matTooltip="{{'general.edit' | transloco}}">edit</mat-icon>
                  </span>
                                    }
                                </td>
                            </ng-container>
                        }
                        <ng-container matColumnDef="expandedPanel">
                            <td mat-cell *matCellDef="let element; let index = dataIndex" colspan="2" style="padding-right: 0;">
                                <div class="edit-panel-wrapper"
                                     [@detailExpand]="element == expandedRow ? 'expanded' : 'collapsed'">
                                    <div class="edit-panel">
                                        <mat-form-field>
                                            <mat-label>title</mat-label>
                                            <input matInput #inputTitle inputrestriction="basic3" type="text" [value]="element.title[0]" autocomplete="off"
                                                   (keydown.enter)="onEmbeddedUpdated(index, 'title', $event.target['value'])" (blur)="editRow.title = $event.target['value']">
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>description</mat-label>
                                            <input matInput #inputDescription inputrestriction="basic3" type="text" [value]="element.description[0]" autocomplete="off"
                                                   (keydown.enter)="onEmbeddedUpdated(index, 'description', $event.target['value'])" (blur)="editRow.description = $event.target['value']">
                                        </mat-form-field>
                                    </div>
                                    <a mat-icon-button class="icon-edit-done" (click)="onEmbeddedUpdated(index)">
                                        <!--                                <mat-icon style="font-size: 15px !important; color: #01ff01" matTooltip="{{'general.update' | transloco}}">check</mat-icon>-->
                                        <mat-icon [ngStyle]="{'color': 'var(--background-green)'}" style="font-size: 18px !important;" matTooltip="{{'general.save' | transloco}}"> check</mat-icon>
                                    </a>
                                </div>
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="onSelectedRow(row)" class="table-row" tabindex="1" [style.background]="highlightedRows.indexOf(row) > -1 ? 'var(--background-default2)' : ''"></tr>
                        <tr mat-row *matRowDef="let row; columns: ['expandedPanel']" class="edit-panel-row"></tr>
                    </table>
                </div>
            }
            <br/><br/>
            <mat-label>
                {{ 'general.embeddedTitle' | transloco }}
            </mat-label>
            <!--        [hideAlignment]="true"-->

            <div *ngIf="showDescriptionFontSelector">
                <app-font-selector (onChange)="onFontChanged($event, 'Title', 'Rss')" [hideVerticalAlignment]="false"
                                   [setConfig]="{i_config: sceneItem, pickArray: 0}"></app-font-selector>
            </div>
            <div *ngIf="!showDescriptionFontSelector">
                <app-font-selector (onChange)="onFontChanged($event, 'Title', 'Rss')" [showOnlyVertical]="true"
                                   [setConfig]="{i_config: sceneItem, pickArray: 0}"></app-font-selector>
            </div>

            <hr/>
            <mat-label>
                {{ 'general.embeddedDetails' | transloco }}
            </mat-label>
            <br/>
            <!--        [hideAlignment]="true"-->
            @if (showDescriptionFontSelector) {
                <app-font-selector (onChange)="onFontChanged($event, 'Description', 'Rss')" [hideVerticalAlignment]="true"
                                   [setConfig]="{i_config: sceneItem, pickArray: 1}"></app-font-selector>
            }
            <hr/>
        </div>
    }
</div>
